import { Theme } from '@mui/material'

export const overrideTabColour = (theme: Theme) => {
  return {
    borderRight: 1,
    borderColor: 'divider',
    '& .MuiTabs-indicator': {
      bgcolor: theme.palette.info.main + '!important',
    },
    '& .MuiTabs-flexContainer': {
      '& .MuiButtonBase-root': {
        color: theme.palette.info.main + '!important',
      },
    },
  }
}

export function explanationText(
  file: any,
  explanation: string,
  setExplanation: any,
) {
  fetch(file)
    .then((response) => response.text())
    .then((textContent) => setExplanation(textContent))
  return explanation || 'Loading...'
}
